import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Craft from "../components/Craft";
import About from "../components/About";
import Toolkit from "../components/Toolkit";
import Band from "../components/Band";
import Stats from "../components/Stats";
import CTA from "../components/CTA";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import { useRiseObserver } from "../hooks/useRiseObserver";

export default function HomePage() {
  const rootRef = useRiseObserver<HTMLDivElement>();

  return (
    <div className="taste" ref={rootRef}>
      <Navbar />
      <main id="main-content">
        <Hero />
        <Services />
        <Craft />
        <About />
        <Toolkit />
        <Band />
        <Stats />
        <CTA />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}
